<script lang="ts">
  import { getContext, onMount, setContext } from "svelte"
  import { CUSTOM_CSS_NAMES } from "website_script/lib/customCss"
  import { getDealerThemeTokensStyle } from "website_script/lib/dealerTheme"
  import type { DealerTheme } from "conversion_flows/shared/contexts/dealerTheme"
  import wrapperElStore from "website_script/stores/wrapper"
  import type { Settings } from "website_script/types/settings"
  const dealerTheme = getContext<DealerTheme>("dealerTheme")
  const settings = getContext<Settings>("settings")
  setContext("wrapperElStore", wrapperElStore)
  let wrapperEl: HTMLDivElement
  onMount(() => {
    // Set wrapperElStore to the wrapperEl on mount
    // This is used to pass the wrapperEl to components that need it to use it as the portal target
    wrapperElStore.set(wrapperEl)
  })
</script>

<div
  id={CUSTOM_CSS_NAMES.FLOATING_CONTAINER}
  class="au-wrapper"
  bind:this={wrapperEl}
  style={getDealerThemeTokensStyle(dealerTheme)}
>
  <slot />
</div>

{#if settings.customCss}
  {@html `<${"style"}>${settings.customCss}</${"style"}>`}
{/if}

<style>
  .au-wrapper {
    display: contents;
    font-style: normal;
    font-weight: normal;
    text-decoration: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    white-space: normal;
    font-kerning: auto;
    font-variant: normal;
    font-feature-settings: normal;
  }
  .au-wrapper :global(*),
  .au-wrapper :global(*)::before,
  .au-wrapper :global(*)::after {
    box-sizing: border-box;
  }
  :global(.au-sr-only) {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
</style>
